<template>
  <ais-stats class="products-listing-results-count">
    <template v-slot="{ nbHits }">
      <span class="products-listing-results-count__number">{{ nbHits }}</span>
      {{ name }}{{ nbHits === 1 ? '' : 's' }}
    </template>
  </ais-stats>
</template>

<script>
  import { AisStats } from 'vue-instantsearch'

  export default {
    name: 'ProductsListingResultsCount',
    components: {
      AisStats
    },
    props: {
      name: {
        type: String,
        default: 'result'
      }
    }
  }
</script>

<style scoped lang="scss">
  .products-listing-results-count {
    font-family: 'MotivaSans Light';
    font-size: 1.4rem;

    &__number {
      font-family: 'MotivaSans SemiBold';
    }
  }
</style>